import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ToolbarComponent,
  ToolbarItemBeforeDirective,
  ToolbarItemCenterDirective,
  ToolbarItemAfterDirective,
} from './toolbar.component';

const declarations = [
  ToolbarComponent,
  ToolbarItemBeforeDirective,
  ToolbarItemCenterDirective,
  ToolbarItemAfterDirective,
];

@NgModule({
  imports: [CommonModule],
  declarations,
  exports: declarations,
})
export class ToolbarModule {}
